/* ==========================================================================
   Siraat — Hammered Pan Pro PDP · V3
   Loaded (deferred) by the sv3_stars block on the V3 pan templates only
   (product.hammered-pan-new + product.a-variant-without-bundle).

   2026-07-12 performance pass: the size-tile price/use-note decorator (a
   client-side /products/{handle}.js fetch per tile) is GONE — tiles now
   render their price and use-note server-side in Liquid
   (snippets/product-info.liquid, custom_size_variant block), and the size
   selector's whole-section re-render keeps them in sync on size change.
   The MutationObserver that re-applied the decorations is gone with it.

   What remains (both handlers are delegated on document, so they survive
   the size selector's whole-section outerHTML replacement):
   1. Smooth-scroll for the stars/reviews link.
   2. Linked-option (lv-option app) button text split — migrated from the
      Custom Liquid block liquid_ePDQi8; pairs with the lv-option CSS in
      siraat-v3-pdp.css.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__sv3Init) return;
  window.__sv3Init = true;

  /* delegated reviews-link scroll — survives section re-render */
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('.sv3-reviews-link');
    if (!link) return;
    var reviews =
      document.querySelector('.oke-w-header-content-block') ||
      document.querySelector('[class*="oke-w"]') ||
      document.querySelector('#okendo-reviews');
    if (reviews) {
      e.preventDefault();
      reviews.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  /* linked-option (lv-option app) button text split — migrated from the
     Custom Liquid block liquid_ePDQi8. Splits each button label into a
     main + sub line for the CSS in siraat-v3-pdp.css. */
  document.addEventListener('king-linked-option-product-loaded', function () {
    var buttonContainer = document.querySelector('.lv-option-box[data-tpl="Default Siraat"]');
    if (!buttonContainer) return;
    var buttons = buttonContainer.querySelectorAll('.lv-option-button');
    buttons.forEach(function (button) {
      var text = button.textContent.trim();
      var match = text.match(/^(\S+)\s+(.*)$/);
      if (match) {
        button.innerHTML =
          '<span class="lv-option-button-text-main">' + match[1] + '</span>' +
          '<span class="lv-option-button-text-sub">' + match[2] + '</span>';
      }
    });
  });

  /* ========================================================================
     sv3-qty engine — quantity tiers block (sv3_qty_tiers)
     Markup in snippets/siraat-v3-qty-tiers.liquid. All handlers are
     delegated on document so they survive the custom_size_variant block's
     whole-section outerHTML re-render (which also resets any active set
     tier back to tier 1 — the default state — by replacing the DOM).

     Tier 1  : native behavior, we touch nothing.
     Tier 2/3: hide the size selector (custom-size-variant / variant-picker
               wrappers) and, optionally, the theme price block; show the
               tier's "Includes:" summary; swap the ATC label; suppress the
               sticky bar; on submit, add the tier's variants via
               /cart/add.js instead of the single selected variant.
     ===================================================================== */
  var HIDE_WHEN_SET = '[data-block-type="custom-size-variant"], [data-block-type="variant-picker"]';

  function sv3QtyState(qtyEl) {
    var on = qtyEl.querySelector('.sv3-qty__opt.is-on');
    return on ? on : null;
  }

  function sv3QtySection(qtyEl) {
    return qtyEl.closest('[id^="shopify-section-"]') || document;
  }

  function sv3QtyAtcButton(qtyEl) {
    var section = sv3QtySection(qtyEl);
    var buyWrap = section.querySelector('[data-block-type="buy-buttons"]');
    if (!buyWrap) return null;
    return buyWrap.querySelector('button[type="submit"], [type="submit"]');
  }

  /* The theme button wraps its label in <button-content> (optionally with
     rotated-text/up-text animation attributes mirroring the label). Swap the
     text INSIDE that element so the button keeps its structure, styling and
     hover animation — replacing the whole button textContent broke both. */
  function sv3QtyLabelEl(atc) {
    return atc.querySelector('button-content') || atc;
  }
  function sv3QtyGetLabel(atc) {
    return sv3QtyLabelEl(atc).textContent.trim();
  }
  function sv3QtySetLabel(atc, text) {
    var el = sv3QtyLabelEl(atc);
    el.textContent = text;
    if (el.hasAttribute && el.hasAttribute('rotated-text')) el.setAttribute('rotated-text', text);
    if (el.hasAttribute && el.hasAttribute('up-text')) el.setAttribute('up-text', text);
  }

  function sv3QtyApply(qtyEl) {
    var active = sv3QtyState(qtyEl);
    var isSet = active && active.dataset.sv3Tier !== '1';
    var section = sv3QtySection(qtyEl);
    var includes = qtyEl.querySelector('.sv3-qty__includes');
    var atc = sv3QtyAtcButton(qtyEl);

    section.classList.toggle('sv3-qty-set-active', !!isSet);

    section.querySelectorAll(HIDE_WHEN_SET).forEach(function (el) {
      el.style.display = isSet ? 'none' : '';
    });
    if (qtyEl.dataset.hidePrice === 'true') {
      section.querySelectorAll('[data-block-type="price"]').forEach(function (el) {
        el.style.display = isSet ? 'none' : '';
      });
    }

    if (includes) {
      if (isSet && active.dataset.sv3Includes) {
        includes.textContent = active.dataset.sv3Includes;
        var idx = includes.textContent.indexOf(':');
        if (idx > 0 && idx < 24) {
          includes.innerHTML =
            '<strong>' + includes.textContent.slice(0, idx + 1) + '</strong>' +
            includes.textContent.slice(idx + 1).replace(/</g, '&lt;');
        }
        includes.hidden = false;
      } else {
        includes.hidden = true;
      }
    }

    if (atc) {
      if (!atc.dataset.sv3OriginalLabel) atc.dataset.sv3OriginalLabel = sv3QtyGetLabel(atc);
      if (isSet && active.dataset.sv3Atc) {
        sv3QtySetLabel(atc, active.dataset.sv3Atc);
      } else {
        sv3QtySetLabel(atc, atc.dataset.sv3OriginalLabel);
      }
    }

    /* gift ladder: meter fills per tier, gift line flips to its unlocked
       text (green) on the last tier */
    var tierNum = active ? parseInt(active.dataset.sv3Tier, 10) || 1 : 1;
    var tierCount = qtyEl.querySelectorAll('.sv3-qty__opt').length || 3;
    var fill = qtyEl.querySelector('.sv3-qty__meter-fill');
    if (fill) fill.style.width = Math.min(100, (tierNum / tierCount) * 100) + '%';
    var gift = qtyEl.querySelector('.sv3-qty__gift');
    if (gift) {
      var unlocked = tierNum >= tierCount;
      var span = gift.querySelector('span');
      gift.classList.toggle('is-done', unlocked);
      if (span) {
        span.textContent = unlocked && gift.dataset.sv3GiftUnlocked
          ? gift.dataset.sv3GiftUnlocked
          : gift.dataset.sv3GiftLocked || span.textContent;
      }
    }
  }

  /* tier row click */
  document.addEventListener('click', function (e) {
    var opt = e.target.closest && e.target.closest('.sv3-qty__opt');
    if (!opt) return;
    var qtyEl = opt.closest('.sv3-qty');
    qtyEl.querySelectorAll('.sv3-qty__opt').forEach(function (o) {
      o.classList.toggle('is-on', o === opt);
    });
    sv3QtyApply(qtyEl);
  });

  /* -----------------------------------------------------------------------
     Add-to-cart takeover while a set tier is active.

     The theme's <product-form> handles the buy button itself (its own
     submit/click handling runs before a plain document submit listener gets
     a chance), so a submit-only interception is not reliable — verified on
     the wok PDP where the single selected variant was added instead of the
     set. Intercept the CLICK on the buy button in capture phase at the
     document root: that always runs before the theme's element-level
     handlers. The submit interception stays as a backup for keyboard
     (Enter) submits.
     -------------------------------------------------------------------- */
  function sv3QtyActiveSet(node) {
    var section = (node.closest && node.closest('[id^="shopify-section-"]')) || document;
    var qtyEl = section.querySelector('.sv3-qty');
    if (!qtyEl) return null;
    var active = sv3QtyState(qtyEl);
    if (!active || active.dataset.sv3Tier === '1' || !active.dataset.sv3Variants) return null;
    return { qtyEl: qtyEl, active: active };
  }

  function sv3QtyAddSet(state) {
    var items = state.active.dataset.sv3Variants.split(',').map(function (part) {
      var bits = part.trim().split(':');
      return { id: parseInt(bits[0], 10), quantity: parseInt(bits[1] || '1', 10) || 1 };
    }).filter(function (item) { return item.id > 0; });
    if (!items.length) return;

    var atc = sv3QtyAtcButton(state.qtyEl);
    if (atc && atc.getAttribute('aria-busy') === 'true') return; /* same double-submit guard as the theme */
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    /* Mirror the theme's own add flow (js/product-form.js) 1:1 so the button
       loads exactly like a normal add to cart and the drawer re-renders and
       opens itself: aria-busy on the submit buttons (the theme's button-
       content styling renders the spinner), the loading bar only for buttons
       without <button-content>, bundled section IDs collected via
       cart:prepare-bundled-sections, then variant:add on the form and
       cart:change with baseEvent "variant:add" on the document root. */
    var form = atc && atc.getAttribute('form') ? document.getElementById(atc.getAttribute('form')) : null;
    if (!form) {
      var section = sv3QtySection(state.qtyEl);
      form = section.querySelector('form[id^="product-form-"]');
    }
    var submitButtons = atc ? [atc] : [];
    if (form && form.elements) {
      Array.prototype.forEach.call(form.elements, function (el) {
        if (el.type === 'submit' && submitButtons.indexOf(el) === -1) submitButtons.push(el);
      });
    }
    var showLoadingBar = !atc || atc.querySelector('button-content') === null;

    submitButtons.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
    var sectionsToBundle = new Set();
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));
    if (showLoadingBar) {
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
    }

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items, sections: Array.from(sectionsToBundle).join(',') })
    }).then(function (res) {
      if (!res.ok) return res.json().then(function (data) { throw new Error(data.description || data.message || 'Could not add the set to the cart.'); });
      return res.json();
    }).then(function (responseJson) {
      if (state.qtyEl.dataset.afterAdd === 'cart') {
        window.location.href = root + 'cart';
        return;
      }
      return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cartContent) {
        cartContent['sections'] = responseJson['sections'];
        var eventItems = responseJson.hasOwnProperty('items') ? responseJson['items'] : [responseJson];
        if (form) {
          form.dispatchEvent(new CustomEvent('variant:add', {
            bubbles: true,
            detail: { items: eventItems, cart: cartContent }
          }));
        }
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: { items: eventItems, cart: cartContent, baseEvent: 'variant:add' }
        }));
      });
    }).catch(function (err) {
      alert(err.message || 'Could not add the set to the cart. Please try again.');
    }).finally(function () {
      submitButtons.forEach(function (b) { b.removeAttribute('aria-busy'); });
      if (showLoadingBar) {
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
      }
    });
  }

  /* primary: capture-phase click on any buy/submit button of the product form */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var btn = e.target.closest('[data-block-type="buy-buttons"] button, button[form^="product-form-"], [data-block-type="buy-buttons"] [type="submit"]');
    if (!btn) return;
    if (btn.closest('.sv3-qty')) return; /* our own tier rows are buttons too */
    var state = sv3QtyActiveSet(btn);
    if (!state) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    sv3QtyAddSet(state);
  }, true);

  /* backup: keyboard (Enter) submits that bypass a button click */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.id || form.id.indexOf('product-form-') !== 0) return;
    var state = sv3QtyActiveSet(form);
    if (!state) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    sv3QtyAddSet(state);
  }, true);
})();
